import React, { useRef, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import {
  Grid,
  makeStyles,
  Paper,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Button,
} from "@material-ui/core";
import moment from 'moment';

import { BuscadorMesaEntrada } from './BuscadorMesaEntrada';
import { buscadorComprobanteMesaEntradaGestion, deleteComprobanteMesaEntrada, setEstadosComprobante } from '../../../actions/mesaEntrada/mesaEntradaActions';
import { DESTINOS_COMPROBANTE, ESTADOS_COMRPOBANTES, MENU_MESA_ENTRADA, MESA_ENTRADA_COMPROBANTES_ESTADOS, MESA_ENTRADA_GESTION_BUTTONS, TIPO_COMPROBANTE_DOCUMENTO, TIPO_EFECTORES } from '../../../utils/constants';
import ToolbarXLSPDF from '../../compartidos/ToolbarXLSPDF';
import { ModalComprobantes } from '../UI/ModalComprobantes';
import { useForm } from '../../../hooks/useForm';
import { GestionComprobanteButtons } from '../UI/GestionComprobanteButtons';
import { generateExcelMesaEntradaGestion } from '../../../actions/mesaEntrada/documentacionMesaEntradaActions';
import { GenericCheckboxTable } from '../../atomic/organisms/GenericTable';
import { MESA_ENTRADA_PERMISOS } from '../../../utils/permisos';
import Info from '../../ui/Info';
import { ModalHistorialExpedientes } from '../UI/ModalHistorialExpedientes';
import IconEstado from '../../autorizaciones/UI/IconEstado';
import { ImpresionComprobante } from '../UI/ImpresionComprobante';
import { ModalInformacionExpediente } from '../UI/ModalInformacionExpediente';
import { AutoCompleteEfectorFacturacion } from '../../liquidaciones/UI/AutoCompleteEfectorFacturacion';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: theme.spacing(1)
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
}));

const validators = [
  "required",
  "minStringLength:10",
  "maxStringLength:100"
];
const errorMessages = [
  "Debe ingresar un motivo de baja",
  "El motivo de baja debe tener al menos 10 caracteres",
  "El motivo de baja no debe tener más de 100 caracteres"
];

let arrayEstadosComprobantesPrestadores = Object.entries(MESA_ENTRADA_COMPROBANTES_ESTADOS);
let arrayEstadosComprobantesDocumento = Object.entries(MESA_ENTRADA_COMPROBANTES_ESTADOS)
  .filter(item => item[1] !== MESA_ENTRADA_COMPROBANTES_ESTADOS.PROFORMA);

export const GestionComprobantes = ({ comprobantes, setComprobantes }) => {
  const classes = useStyles();
  const componentRef = useRef();
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState('');

  const {
    efectorSeleccionado,
  } = useSelector((state) => state.liquidaciones);


  const stateInitial = {
    fechaDesde: moment().format(),
    fechaHasta: moment().format(),
    idTipoEfector: TIPO_EFECTORES.CONTRATO_PRESTADORES,
    tipoComprobanteDocumento: TIPO_COMPROBANTE_DOCUMENTO.DOCUMENTACION,
    idSubArea: useSelector(state => state.auth.areasFisicasUsuario?.idSubArea),
    idEfectorFacturacion: ''
  };

  const [
    formValues,
    handleInputChange, ,
    setearValor
  ] = useForm(stateInitial);

  const {
    activeBreadcrumb,
    estadoComprobante,
    tipoComprobanteDocumentoMenu,
    destinos,
    comprobantes: items
  } = useSelector(state => state.mesaEntrada);



  const menuEmbargo = tipoComprobanteDocumentoMenu === TIPO_COMPROBANTE_DOCUMENTO.EMBARGO;
  const menuPrestadoresGestion = activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES;
  const arrayEstadosComprobantes = menuPrestadoresGestion ? arrayEstadosComprobantesPrestadores : arrayEstadosComprobantesDocumento;

  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [expedientesRetorno, setExpedientesRetorno] = useState(null)
  const [idExpedientes, setIdExpedientes] = useState([]);
  const [idDestino, setIdDestino] = useState(menuPrestadoresGestion ? DESTINOS_COMPROBANTE.LIQUIDACIONES : DESTINOS_COMPROBANTE.SECRETARIA_ADMINISTRATIVA);

  const disabledCheck = estadoComprobante === MESA_ENTRADA_COMPROBANTES_ESTADOS.ANULADA.toString() || estadoComprobante === MESA_ENTRADA_COMPROBANTES_ESTADOS.PROFORMA.toString() || comprobantes.length === 0;

  useEffect(() => {
    if (parseInt(estadoComprobante) === MESA_ENTRADA_COMPROBANTES_ESTADOS.PENDIENTE_ENVIO)
      setComprobantes(items.filter(item =>
        item.idEstado === ESTADOS_COMRPOBANTES.PENDIENTE_ENVIO ||
        item.idEstado === ESTADOS_COMRPOBANTES.RETORNADA)
      );
    else if (parseInt(estadoComprobante) === MESA_ENTRADA_COMPROBANTES_ESTADOS.ANULADA)
      setComprobantes(items.filter(item => item.idEstado === ESTADOS_COMRPOBANTES.ANULADA));
    else if (parseInt(estadoComprobante) === MESA_ENTRADA_COMPROBANTES_ESTADOS.ENVIADA)
      setComprobantes(items.filter(item => item.idEstado === ESTADOS_COMRPOBANTES.ENVIADA));
    else if (parseInt(estadoComprobante) === MESA_ENTRADA_COMPROBANTES_ESTADOS.PROFORMA)
      setComprobantes(items.filter(item =>
        item.idEstado === ESTADOS_COMRPOBANTES.PROFORMA_ENVIADA ||
        item.idEstado === ESTADOS_COMRPOBANTES.PROFORMA_PAGADA ||
        item.idEstado === ESTADOS_COMRPOBANTES.PROFORMA_IMPUTADA ||
        item.idEstado === ESTADOS_COMRPOBANTES.PROFORMA_ASIGNADA
      ));
  }, [items, estadoComprobante]);

  useEffect(() => {
     setearValor("idEfectorFacturacion", efectorSeleccionado?.idEfectorFacturacion ? efectorSeleccionado?.idEfectorFacturacion : null);
  }, [efectorSeleccionado])

  const handleOpenModal = (e, data) => {
    e.preventDefault();
    if (data.action === MESA_ENTRADA_GESTION_BUTTONS.MODIFICAR_DESTINO) {
      if (data.single) {
        setIdExpedientes([data.item?.idExpediente]);
        setIdDestino(data.item?.idDestino);
      } else {
        setIdExpedientes(data.idExpediente);
      }
      setOpen(true);
    } else {
      setExpedientesRetorno(data)
      setOpen(true);
    }
  };

  const [openModalInformacion, setOpenModalInformacion] = useState({
    open: false,
    value: null
  });
  const [openModalHistorialCambios, setOpenModalHistorialCambios] = useState({
    open: false,
    value: null
  });
  const [motivoBaja, setMotivoBaja] = useState({
    active: true,
    text: ""
  });

  const handleDelete = (idExpediente) => {
    dispatch(deleteComprobanteMesaEntrada({ idExpediente, motivoBaja: motivoBaja.text, gestion: formValues }));
  };


  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <BuscadorMesaEntrada
          formValues={formValues}
          setSelected={setSelected}
          handleInputChange={handleInputChange}
          setearValor={setearValor}
          setInputValue={setInputValue}
        />
        <Grid item xs={12}>
          <Grid container component={Paper} alignItems="center" style={{ padding: "0.25rem" }}>
            <Grid item xs={2} style={{ padding: "0.5em 1em", gap: "0.5em", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <TextField
                variant="outlined"
                margin='normal'
                fullWidth
                label="Id Comp - Id Comp SV"
                onChange={e => setInputValue(e.target.value)}
                autoComplete="off"
                type="number"
                value={inputValue}
                InputLabelProps={{ style: { fontWeight: 'bold' } }}
              />
              <Button
                variant="contained"
                color="primary"
                size='small'
                disabled={inputValue.length < 5}
                onClick={() => {
                  dispatch(buscadorComprobanteMesaEntradaGestion({
                    idTipoEfector: formValues.idTipoEfector,
                    tipoComprobanteDocumento: formValues.tipoComprobanteDocumento,
                    buscador: inputValue
                  }, setInputValue))
                }}
                style={{
                  marginTop: '5px',    
                }}
              >
                Buscar por ID
              </Button>
            </Grid>
            <Grid item xs={3} style={{ padding: "0.5em 1em", gap: "0.5em", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <AutoCompleteEfectorFacturacion todos dontExecuteFetch />
            </Grid>
            <Grid item xs={12} md={4}>
              <RadioGroup
                row
                style={{ justifyContent: "space-around" }}
                value={estadoComprobante}
                onChange={(e) => {
                  setSelected([]);
                  dispatch(setEstadosComprobante(e.target.value));
                }}
              >
                {arrayEstadosComprobantes.map((estadoComprobante) => {
                  const label =
                    estadoComprobante[0].charAt(0) +
                    estadoComprobante[0].replace("_", " ").toLowerCase().slice(1);
                  return (
                    <FormControlLabel
                      key={estadoComprobante[1]?.toString()}
                      style={{ marginLeft: "0.5rem" }}
                      label={label === ('Proforma envio' || 'Proforma pagada' || 'Proforma imputada') ? 'Proforma' : label}
                      value={estadoComprobante[1]?.toString()}
                      control={<Radio />}
                    />
                  );
                })}
              </RadioGroup>
            </Grid>
            <Grid item xs={12} md={3} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <GestionComprobanteButtons formValues={formValues}
                selected={selected}
                setSelected={setSelected}
                handleOpenModal={handleOpenModal}
                estadoComprobante={estadoComprobante}
              />
              <ToolbarXLSPDF
                handleExportExcel={() => dispatch(generateExcelMesaEntradaGestion(estadoComprobante, formValues))}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} component={Paper} style={{ marginTop: "0.5em" }}>
            <GenericCheckboxTable
              ref={componentRef}
              align="center"
              selected={selected}
              setSelected={setSelected}
              data={comprobantes.map(item => ({ ...item, id: item.idExpediente }))}
              disabledCheck={disabledCheck}
              withoutPagination={comprobantes.length === 0}
              withDeleteButton={{
                condition: (item) => (
                  item.idEstado === ESTADOS_COMRPOBANTES.PENDIENTE_ENVIO ||
                  item.idEstado === ESTADOS_COMRPOBANTES.RETORNADA ||
                  item.idEstado === ESTADOS_COMRPOBANTES.PROFORMA_ENVIADA
                ),
                deleteProps: {
                  handleDelete: (item) => handleDelete(item.idExpediente),
                  mensajeEliminacion: "¿Desea anular este comprobante?",
                  permiso: MESA_ENTRADA_PERMISOS.BAJA,
                  motivoBaja, setMotivoBaja, validators, errorMessages
                }
              }}
              columns={[
                {
                  label: "Historial",
                  customBody: (item) => (
                    <Info onClick={() => setOpenModalHistorialCambios({ open: true, value: item })} />
                  )
                },
                {
                  label: "Estado",
                  customBody: (item) => (
                    <IconEstado
                      useColorTable={true}
                      texto={item?.letra}
                      backgroundColor={item?.color}
                      descripcion={item?.descripcionEstado}
                    />
                  )
                },
                {
                  label: "Id Comprobante",
                  id: "idExpediente",
                  sort: true
                },
                {
                  label: "Id Comprobante SV",
                  id: "idExpedientes",
                  sort: true
                },
                {
                  label: "Fecha Recepción",
                  customBody: (item) => moment(item?.fechaRecepcion).format("DD/MM/YYYY")
                },
                ...(menuPrestadoresGestion ? [
                  (formValues.proveedor ? {
                    label: "Proveedores",
                    customBody: (item) => item?.razonSocial || item?.nombreFantasia
                  } : {
                    label: "Prestadores",
                    customBody: (item) => item?.razonSocial || item?.nombreFantasia
                  }
                  ),
                  {
                    label: "Tipo Comprobante",
                    id: "descripcionTipoComprobante"
                  },
                  {
                    label: "N° Comprobante",
                    customBody: (item) => item.nroFactura ?
                      item?.descripcionTipoFactura
                        ? `${item.descripcionTipoFactura} / ${item?.nroSucursal.toString().padStart((5), '0') || "00000"}-${item?.nroFactura.toString().padStart((8), '0')}`
                        : `${item?.nroSucursal.toString().padStart((5), '0')}-${item?.nroFactura.toString().padStart((8), '0')}`
                      : "No posee N° Comprobante"
                  },
                  {
                    label: "Total Comprobante",
                    customBody: (item) => `$ ${parseFloat(item?.totalComprobante).toFixed(2)}`
                  },
                  {
                    label: "Fecha Comprobante",
                    customBody: (item) => moment(item?.fechaInicioVigencia).format("DD/MM/YYYY")
                  },
                  {
                    label: "Fecha Vencimiento",
                    customBody: (item) => moment(item?.fechaFinVigencia).format("DD/MM/YYYY")
                  }
                ] : [
                  ...(menuEmbargo ? [
                    {
                      label: "Cuit",
                      id: "cuit"
                    },
                    {
                      label: "CBU Embargo",
                      id: "cbuEmbargo"
                    },
                    {
                      label: "Auto Documento",
                      id: "autos"
                    },
                    {
                      label: "Importe",
                      customBody: (item) => `$ ${parseFloat(item?.importe).toFixed(2)}`
                    }
                  ] : [
                    {
                      label: "Fecha Carta",
                      customBody: (item) => moment(item?.fechaCarta).format("DD/MM/YYYY")
                    },
                    {
                      label: "Caratula",
                      id: "caratula"
                    },
                    {
                      label: "Entregado Por",
                      id: "entregadoPor"
                    },
                    {
                      label: "Folios",
                      id: "folios"
                    }
                  ])
                ]),
                ...(menuPrestadoresGestion && parseInt(estadoComprobante) !== MESA_ENTRADA_COMPROBANTES_ESTADOS.PROFORMA ? [{
                  label: "Proforma Asignada",
                  customBody: (item) => item?.idComprobanteAsignado || item?.idComprobanteAsignado
                }] : []),
                {
                  sort: true,
                  label: "Destino",
                  id: "idDestino",
                  customBody: (item) => (
                    <Button
                      variant={estadoComprobante !== '1' ? "contained" : "outlined"}
                      color="secondary"
                      disabled={estadoComprobante !== '1'}
                      onClick={e => handleOpenModal(e, {
                        item,
                        action: MESA_ENTRADA_GESTION_BUTTONS.MODIFICAR_DESTINO,
                        single: true
                      })}
                    >
                      {destinos.find(destino => destino?.id === item.idDestino)?.descripcion}
                    </Button>
                  )
                },
                {
                  label: "Información",
                  customBody: (item) => (
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => setOpenModalInformacion({ open: true, value: item })}
                      type='submit'
                    >
                      VER
                    </Button>
                  )
                },
                {
                  label: "Impresion",
                  customBody: (item) => (
                    <ImpresionComprobante comprobante={item} documento={!menuPrestadoresGestion} />
                  )
                },
              ]}
            />
          </Grid>
        </Grid>
        {open &&
          (idExpedientes.length !== 0 || expedientesRetorno !== null) &&
          <ModalComprobantes
            setOpen={setOpen}
            open={open}
            retorno={{
              expedientesRetorno,
              setExpedientesRetorno
            }}
            idExpedientes={idExpedientes}
            idDestino={idDestino}
            setIdDestino={setIdDestino}
            setSelected={setSelected}
          />
        }
        {openModalHistorialCambios.open && (
          <ModalHistorialExpedientes
            open={openModalHistorialCambios}
            closeModalHandler={() => {
              setOpenModalHistorialCambios({ open: false, value: null });
            }}
            expediente={openModalHistorialCambios.value}
          />
        )}
        {openModalInformacion.open && (
          <ModalInformacionExpediente
            open={openModalInformacion}
            tipoComprobanteDocumento={formValues.tipoComprobanteDocumento}
            closeModalHandler={() => {
              setOpenModalInformacion({ open: false, value: null });
            }}
            expediente={openModalInformacion.value}
          />
        )}
      </Grid>
    </div>
  )
}
